import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import PaginationResponse from '@/common/pagination/entities/pagination-response'
import Competence from '@/competences/entities/competence'
import CompetenceFilter from '@/competences/entities/competence-filter'

class CompetencesService {
  public async findAllAsync(filter: CompetenceFilter) {
    const res = await axios.post<Competence[]>(`competences/filter`, filter)
    return Responses.list(res)
  }

  public async findAllPagedAsync(filter: CompetenceFilter) {
    const res = await axios.post<PaginationResponse<Competence>>(
      `competences/filter/paged`,
      filter
    )
    return Responses.pagedList(res)
  }

  public async createAsync(entity: Competence) {
    return await axios.post<Competence>(`competences`, entity)
  }

  public async updateAsync(entity: Competence) {
    await axios.put<any>(`competences`, entity)
  }

  public async removeAsync(id: string) {
    await axios.delete(`competences/${id}`)
  }

  public async moveUpAsync(id: string) {
    await axios.post(`competences/up/${id}`)
  }

  public async moveDownAsync(id: string) {
    await axios.post(`competences/down/${id}`)
  }

  public async importAsync(file: File) {
    const formData = new FormData()
    formData.append('file', file, file.name)
    const res = await axios.post(`competences/import`, formData)
    return res.data
  }
}

export default new CompetencesService()
